import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'antd'
import { CartAnotherOrder } from 'components'
import defaultImg from 'app/assets/images/default.png'
// import { getAuthorName } from "utils";
import './index.less'

interface OrderTableProps {
  data?: SwaggerDTO.我的订单分页查询订单返回对象
  receiptHandle?: Function
}

export const statusText = {
  /**待发货 */
  0: '待发货',
  /**已发货 */
  1: '交易完成',
  4: '交易完成',
  /**取消订单 */
  3: '交易取消',
  8: '交易取消',
  /**待收货 */
  5: '待收货',
}
export default function OrderTable({ data, receiptHandle }: OrderTableProps) {
  const history = useHistory()

  // 详情
  const detailHandle = () => {
    history.push(`/mine/order-detail/${data?.orderNo}`)
  }

  const openDetail = row => {
    // 文创
    if (row?.contentType === 3) {
      history.push(`/detail/booart?spuCode=${row?.spuNo}`)
    }
    // 图书
    if ([1, 4].includes(row?.contentType!)) {
      history.push(`/detail/book?spuCode=${row?.spuNo}`)
    }
  }

  return (
    <tbody>
      <tr className="sep-row">
        <td colSpan={4}></td>
      </tr>
      <tr className="tr-th">
        <td colSpan={5}>
          <span className="dealTime">{data?.createTime}</span>
          <span className="number">
            订单编号：<span>{data?.orderNo}</span>
          </span>
        </td>
      </tr>
      {data?.goods?.map(
        (item, index) =>
          index < 3 && (
            <tr className="tr-bd" key={item.spuNo}>
              <td>
                <div className="goods">
                  <div className="goods-item">
                    <div className="g-img" onClick={() => openDetail(item)}>
                      <img src={item.skuImageUrl || defaultImg} alt="" />
                    </div>
                    <div className="g-msg">
                      <p className="g-name">{item.skuName}</p>
                      {[1, 4].includes(item?.contentType) && (
                        <>
                          <p className="g-order">作者：{item.authorName}</p>
                          <p className="g-order">出版社：{item.pressName}</p>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="goods-number">x{item.salesNum}</div>
                </div>
              </td>

              {!index && (
                <>
                  <td rowSpan={data?.goods.length}>
                    <div className="amount">
                      ¥<span>{data.orderAmount?.toFixed(2)}</span>
                    </div>
                  </td>
                  <td rowSpan={data?.goods.length}>
                    <div className="consignee">{data.consigneeMan}</div>
                  </td>
                  <td rowSpan={data?.goods.length}>
                    <div className="status">{statusText?.[data.status]}</div>
                  </td>
                  <td rowSpan={data?.goods.length}>
                    <div className="btn">
                      {data.status === 5 && (
                        <Button
                          type="link"
                          size="small"
                          onClick={() =>
                            Modal.confirm({
                              title: '提示',
                              content: '确认收到货了吗？',
                              onOk() {
                                receiptHandle?.(data?.orderNo)
                              },
                            })
                          }
                        >
                          确认收货
                        </Button>
                      )}
                      <Button type="link" size="small" onClick={detailHandle}>
                        查看详情
                      </Button>
                      <CartAnotherOrder orderNo={data?.orderNo} />
                    </div>
                  </td>
                </>
              )}
            </tr>
          )
      )}
    </tbody>
  )
}
